import SocketWorker from "./SocketWorker";

export function socketConnection(params) {
  const identity = params?.user || params;
  return SocketWorker(identity?.companyId, identity?.id ?? identity?.userId);
}
